import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';
const base = `${API}/api/sqf`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

// ─── Trainings ────────────────────────────────────────────────────────────────
const getTrainings    = ()       => axios.get(`${base}/trainings`, auth()).then(r => r.data.trainings);
const createTraining  = (data)   => axios.post(`${base}/trainings`, data, auth()).then(r => r.data.training);
const getTraining     = (id)     => axios.get(`${base}/trainings/${id}`, auth()).then(r => r.data.training);
const updateTraining  = (id, d)  => axios.put(`${base}/trainings/${id}`, d, auth()).then(r => r.data.training);
const archiveTraining = (id)     => axios.delete(`${base}/trainings/${id}`, auth()).then(r => r.data);

// ─── Versions ─────────────────────────────────────────────────────────────────
const createVersion  = (tid, d)        => axios.post(`${base}/trainings/${tid}/versions`, d, auth()).then(r => r.data.version);
const updateVersion  = (tid, vid, d)   => axios.put(`${base}/trainings/${tid}/versions/${vid}`, d, auth()).then(r => r.data.version);
const publishVersion = (tid, vid)      => axios.post(`${base}/trainings/${tid}/versions/${vid}/publish`, {}, auth()).then(r => r.data);
const deleteVersion  = (tid, vid)      => axios.delete(`${base}/trainings/${tid}/versions/${vid}`, auth()).then(r => r.data);

// ─── Clause Links ─────────────────────────────────────────────────────────────
const getTrainingClauses   = (tid)    => axios.get(`${base}/trainings/${tid}/clauses`, auth()).then(r => r.data.clauses);
const addTrainingClause    = (tid, d) => axios.post(`${base}/trainings/${tid}/clauses`, d, auth()).then(r => r.data);
const removeTrainingClause = (tid, clauseId) => axios.delete(`${base}/trainings/${tid}/clauses/${clauseId}`, auth()).then(r => r.data);

// ─── Employees (for assignment picker) ────────────────────────────────────────
const getTrainingEmployees = () => axios.get(`${base}/training-employees`, auth()).then(r => r.data.employees);

// ─── Assignments ──────────────────────────────────────────────────────────────
const getAssignments   = (params = {}) => axios.get(`${base}/training-assignments`, { ...auth(), params }).then(r => r.data.assignments);
const createAssignments = (data)       => axios.post(`${base}/training-assignments`, data, auth()).then(r => r.data);
const getAssignment    = (id)          => axios.get(`${base}/training-assignments/${id}`, auth()).then(r => r.data.assignment);
const revokeAssignment = (id)          => axios.delete(`${base}/training-assignments/${id}`, auth()).then(r => r.data);

// ─── AI Generation ────────────────────────────────────────────────────────────
// Uses fetch+stream so the SSE keepalive pings keep the connection alive past Heroku's 30s timeout.
const generateTraining = (data) => new Promise(async (resolve, reject) => {
  let response;
  try {
    response = await fetch(`${base}/ai/generate-training`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
      body: JSON.stringify(data),
    });
  } catch (err) {
    return reject(err);
  }
  if (!response.ok || !response.body) {
    const err = await response.json().catch(() => ({}));
    return reject(Object.assign(new Error(err.message || 'Request failed'), { response: { data: err } }));
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  while (true) {
    const { done, value } = await reader.read();
    if (value) buffer += decoder.decode(value, { stream: !done });
    const parts = buffer.split('\n\n');
    buffer = done ? '' : parts.pop();
    for (const part of parts) {
      const line = part.split('\n').find(l => l.startsWith('data: '));
      if (!line) continue;
      try {
        const event = JSON.parse(line.slice(6));
        if (event.type === 'done') return resolve(event.training);
        if (event.type === 'error') return reject(Object.assign(new Error(event.message), { response: { data: { message: event.message } } }));
      } catch { /* ignore malformed event */ }
    }
    if (done) return reject(new Error('Connection closed without a result.'));
  }
});
const regenerateQuestion  = (data) => axios.post(`${base}/ai/regenerate-question`, data, auth()).then(r => r.data.question);

const sqfTrainingService = {
  getTrainingEmployees,
  getTrainings, createTraining, getTraining, updateTraining, archiveTraining,
  createVersion, updateVersion, publishVersion, deleteVersion,
  getTrainingClauses, addTrainingClause, removeTrainingClause,
  getAssignments, createAssignments, getAssignment, revokeAssignment,
  generateTraining, regenerateQuestion,
};

export default sqfTrainingService;
